import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const api = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/list-email?" + qstr);
  },
  getExcel() {
    return api.get("/list-email/export");
  },
  getBirthdayMail() {
    return api.get("/birthday_mail");
  },
  updateBirthdayMail(inputs) {
    return api.put("/birthday_mail", inputs);
  },
  getBlackList() {
    return api.get("/black-list");
  },
  updateBlackList(inputs) {
    return api.put("/update-black-list", inputs);
  },
  getTypeSubscribe() {
    return api.get("/type-subscribe");
  },
  getAllStatus() {
    return api.get("/status-subscribe");
  },
  updateStatus(id, status) {
    return api.put("/update-status-newsletter/" + id, status);
  },
  deleteMail(data) {
    return api.delete("/delete-subscribe", { data });
  }
};
